<section>
  <div #sideSection class="background-background">
    <div class="nav-item" *ngFor="let item of settingsNavItems">
      <ion-button
        [routerLink]="'/settings' + item.href"
        (click)="linkClick()"
        class="nav-link lead secondary top-link color-primary-text"
        routerLinkActive="active"
        fill="clear"
        expand="block"
        mode="ios"
      >
        <p class="top-link">{{item.name}}</p>
      </ion-button>

      <ul class="nav nav-pills flex-column" *ngIf="item?.subNav?.length > 0">
        <li class="list-unstyled tr-icon-list" *ngFor="let subItem of item.subNav">
          <ion-button
            [routerLink]="'/settings' + subItem.href"
            (click)="linkClick()"
            class="nav-link secondary"
            [class.disabled]="subItem.disabled"
            routerLinkActive="active"
            fill="clear"
            expand="block"
            mode="ios"
          >
            <div class="text-left">
              <tr-icon [icon]="subItem.icon" [disabled]="subItem.disabled" class="mr-1"></tr-icon>
              <span class="text-capitalize" [ngbTooltip]="subItem.tooltip">{{subItem.name}}</span>
            </div>
          </ion-button>
        </li>
      </ul>
    </div>
  </div>
</section>
